import React from 'react';
import './main.scss'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormLp from './FormLp'
import useMediaQuery from '@material-ui/core/useMediaQuery';


const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));

const Main = () => {
    const classes = useStyles();
    const matches = useMediaQuery('(max-width:960px)');


    return ( 
      <div className='main-container'>
        <div  className={'main'}>
          <div className='container-lp'>
            <div className='main-lp'>
                  <Grid  container >
                      <Grid container   sm={12} md={6} >
                        <div  className={'space-title'}>
                        <img className='image' alt='logo' src='/img/lp-300/logo_lp.svg' />
                          <p className='title-lp'>
                            Se parte de la nueva era<br/>
                            del abogado digital.
                          </p>
                          <ul className="list-lp">
                            <li>Genera nuevos clientes</li>
                            <li>Posiciona fácilmente<br/>tus servicios en línea</li>
                            <li>Recibe reportes en<br/>tiempo real de tu<br/>rendimiento</li>
                          </ul>
                        </div>
                      </Grid>
                      <Grid item sm={12} md={6} justify="center" alignItems="center" >
                      {matches ?  null  : <FormLp /> }
                                 
                      </Grid>
                  </Grid>
            </div>
          </div>
      </div>
      {matches ?  <FormLp />   : null}
      </div>
     );
}
 
export default Main;